import {version} from "../../../config";

export const header = theme => ({
	"@global": {
		body: {
			width: "100vw",
			height: "100vw",
			overflow: "hidden"
		},
	},
	btnBack: {
		display: "inline-flex",
		position: "relative",
		width: 30,
		height: 30,
		minHeight: "auto",
		fontWeight: 900,
		zIndex: 1,
	},
	backActions: {
		position: "absolute",
		top: 10,
		right: theme.spacing.unit * 2,
		display: "flex",
		"& p": {
			lineHeight: "2rem",
			marginRight: theme.spacing.unit * 2,
		},
		fontWeight: 900,
		zIndex: 2,
	},
	logo: {
		height: 50,
		paddingLeft: 20,
		paddingRight: 20,
	},
	// img: {height: "100%"},
	img: {width: "123px"},
	toolbar: theme.mixins.toolbar,
	underHeaderLine: {
		borderTopWidth: 4,
		borderColor: theme.palette.primary.main,
		borderStyle: "solid",
		zIndex: 99,
		position: "absolute",
		width: "100%",
	},
	[theme.breakpoints.down("sm")]: {
		mediaToolbar: {
			position: "fixed",
			width: "100%",
			background: "#fff",
			zIndex: 9,
		},
	},
});
export const main = theme => ({
	"@global": {
		".image-gallery": {
			background: "#333",
		},
		".image-gallery-slides": {
			"& :focus": {
				outline: "none",
			},
		},
		".image-gallery-slide .image-gallery-image": {
			// height: "100vh",
			// objectFit: "cover"
		},
		".image-gallery-content .image-gallery-slide .image-gallery-image": {
			maxHeight: "94vh",
			height: "94vh",
		},
		".office-poi-description": {
			padding: "20px",
			fontWeight: "100!important",
		},
		".afficher": {
			position: "absolute",
			bottom: "97px",
			width: "100%",
		},
		".image-gallery-icon:focus": {
			outline: `2px solid ${theme.palette.primary.main}`,
		},
		".rc-tabs-tab": {
			height: "4rem !important",
			fontSize: "1.6rem !important",
			alignItems: "center",
			margin: "0 !important",
			float: "none !important",
			display: "block",
			width: "100%",
			textAlign: "center",
			lineHeight: "4rem",
			padding: 0,
			textTransform: "uppercase",
			fontFamily: "Questrial,Arial,sans,sans-serif",
		},
		".rc-tabs-bottom .rc-tabs-content": {
			height: "calc(100vh - 50px - 4rem)",
		},
		".rc-tabs-tab-active, .rc-tabs-tab-active:hover": {
			backgroundColor: theme.palette.primary.main,
			color: theme.palette.primary.contrastText,
		},
		".rc-tabs-tab:hover:not(.rc-tabs-tab-active)": {
			backgroundColor: theme.palette.primary.dark,
			color: theme.palette.primary.contrastText,
		},
		".rc-tabs-content .rc-tabs-tabpane": {
			overflow: "hidden",
		},
	},
	poiGallery: {
		background: "#333",
	},
	mainWrapper: {
		width: "100vw",
	},
	appBar: {
		"& > div": {
			display: "flex",
		},
		border: "0 !important",
	},
	tabs: {
		border: 0,
	},
	tab: {
		overflow: "hidden !important",
	},
	selected: {},
	tabWrapper: {},
	iframe: {
		width: "100vw",
		height: "calc(95vh)",
		overflow: "hidden",
	},
	canvas: {},
	canvasFullHeight: {
		height: "calc(100vh - 50px)",
		[theme.breakpoints.down("sm")]: {
			height: "auto",
			width: "100vw",
		},
	},
	[theme.breakpoints.down("sm")]: {
		"@global": {
			".rc-tabs-tab": {
				fontSize: "1rem !important",
			},
			body:{
				background: "#333"
			}
		},
		mainWrapper: {
			width: "100vw",
		},
		appBar: {
			width: "100vw",
		},
		iframe: {
			width: "100vw",
		},
	},
});
export const sidebar = theme => ({
	"@global": {
		".benefitWrapper": {
			margin: 0,
		},
		body: {
			fontSize: "1rem",
		},
	},
	root: {
		width: "20vw",
		height: "100vh",
		boxShadow: "none",
		minWidth: 300,
		padding: 0,
		color: theme.palette.common.white,
		border: 0,
		zIndex: 1,
		position: "relative",
	},
	wrapper: {
		// width: "20vw",
		backgroundColor: theme.palette.common.black,
		height: "100%",
		overflowY: "auto",
		display: "flex",
		flexDirection: "column",
		paddingBottom: "4rem",
	},
	title: {
		display: "flex",
		flexDirection: "column",
		color: "#fff",
		padding: `${theme.spacing.unit * 5}px ${theme.spacing.unit * 2}px ${theme
			.spacing.unit * 5}px`,
		fontSize: "23px",
		lineHeight: "1.3em",
		fontWeight: 600,
		flexShrink: 0,
		flexGrow: 0,
		"& $subTitle": {
			fontSize: "0.8em",
		},
	},
	subTitle: {
		fontSize: "17px",
		color: "#fff",
		fontWeight: 600,
		marginTop: theme.spacing.unit / 2,
		"&.spacer": {
			marginTop: "1vh",
			flexShrink: 0,
			flexGrow: 0,
		},
	},

	value: {
		fontSize: "1.1em",
		fontWeight: 600,
		marginTop: theme.spacing.unit / 2,
		display: "block",
		textAlign: "center",
		"& > span": {
			display: "inline-flex",
			textAlign: "center",
		},
	},
	grid: {
		textAlign: "center",
		color: theme.palette.common.white,
		marginBottom: "2vh",
	},
	icon: {
		width: 35,
		height: 35,
		margin: `0 0 ${theme.spacing.unit}px 0`,
		fill: !version.office
			? theme.palette.primary.main
			: theme.palette.secondary.main,
		fontWeight: 900,
		"@media (min-width:960px) and (max-width:1440px)": {
			width: 24,
			height: 24,
		},
	},

	actions: {
		textAlign: "center",
		justifyContent: "center",
		display: "flex",
		marginTop: "1.5vh",
		"&:last-child": {
			marginTop: "3.5vh",
		},
	},
	btn: {
		padding: "0.7em 1.5em",
		fontSize: "15px",
		marginRight: theme.spacing.unit,
		height: "auto",
		minHeight: "auto",
		"&:last-child": {
			marginRight: 0,
		},
		backgroundColor: "#fff",
	},
	btnBig: {
		padding: "0.8em 1.7em",
		fontSize: "1.5em",
		height: "auto",
		minHeight: "auto",
		borderRadius: theme.spacing.unit * 8,
		color: theme.palette.primary.contrastText,
		backgroundColor: theme.palette.primary.main,
	},
	[theme.breakpoints.down("md")]: {
		"@global": {
			body: {
				fontSize: "0.6rem",
				overflowY: "auto!important",
			},
		},
		wrapper: {
			// width: "20vw",
		},
		drawerPaper: {
			width: "20vw",
		},
		drawerWrapper: {
			padding: `0 ${theme.spacing.unit * 4}px`,
		},
		btn: {
			fontSize: "15px",
		},
		btnBig: {
			fontSize: "1.2em",
		},
	},
	[theme.breakpoints.down("sm")]: {
		"@global": {
			body: {
				fontSize: "1rem",
				overflowY: "auto!important",
			},
			".afficher": {
				position: "relative",
				bottom: "0",
			},
		},
		wrapper: {
			width: "100vw",
			marginTop: "50px",
		},
		drawerPaper: {
			width: "100vw",
		},
		drawerWrapper: {
			padding: `0 ${theme.spacing.unit * 4}px`,
		},
		appBar: {
			width: "100vw",
		},
		".benefitWrapper": {
			display: "flex !important",
			flexDirection: "column",
			alignItems: "center",
		},
	},
});
